var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeSlashIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.185 19.368L13.764 16.9455C12.8278 17.2802 11.8157 17.3422 10.8456 17.1243C9.87554 16.9063 8.98729 16.4173 8.28423 15.7143C7.58117 15.0112 7.09221 14.123 6.87424 13.1529C6.65628 12.1828 6.71827 11.1707 7.053 10.2345L3.963 7.1445C1.407 9.417 0 12 0 12C0 12 4.5 20.25 12 20.25C13.4406 20.245 14.8649 19.9448 16.185 19.368ZM7.815 4.632C9.13508 4.05514 10.5594 3.75496 12 3.75C19.5 3.75 24 12 24 12C24 12 22.5915 14.5815 20.0385 16.857L16.9455 13.764C17.2802 12.8278 17.3422 11.8157 17.1243 10.8456C16.9063 9.87554 16.4173 8.98729 15.7143 8.28423C15.0112 7.58117 14.123 7.09221 13.1529 6.87424C12.1828 6.65628 11.1707 6.71827 10.2345 7.053L7.815 4.6335V4.632Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.28749 11.469C8.20498 12.0455 8.25786 12.6332 8.44194 13.1857C8.62602 13.7382 8.93623 14.2402 9.34801 14.652C9.75979 15.0638 10.2618 15.374 10.8143 15.5581C11.3668 15.7421 11.9545 15.795 12.531 15.7125L8.28599 11.469H8.28749ZM15.7125 12.531L11.469 8.28599C12.0455 8.20348 12.6332 8.25636 13.1857 8.44044C13.7382 8.62452 14.2402 8.93473 14.652 9.34651C15.0638 9.75829 15.374 10.2603 15.5581 10.8128C15.7421 11.3653 15.795 11.953 15.7125 12.5295V12.531ZM20.469 21.531L2.46899 3.53099L3.53099 2.46899L21.531 20.469L20.469 21.531Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeSlashIcon);
export default __webpack_public_path__ + "static/media/eye-slash-icon.84fc959abc544144a97569f54c839d78.svg";
export { ForwardRef as ReactComponent };